import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import env from 'src/env';
import MainLayout from 'src/Components/Pages/MainLayout';
import GET_LOCALE from 'src/graphql/queries/intlQuery';
import { useQuery } from '@apollo/client';
import sparkUpLanguageUrl from 'src/utils/sparkUpLanguageUrl';

const SparkingUpYourWorkshop = () => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [iframeSrc, setIframeSrc] = useState<string>('');
    const intl = useIntl();

    const { data: locale } = useQuery(GET_LOCALE);

    useEffect(() => {
        document.title = intl.formatMessage({ id: 'LP_SPARKING_UP_YOUR_WORKSHOP', defaultMessage: 'Sparking Up Your Workshop' });
    }, [intl]);

    useEffect(() => {
        const localeCode = sparkUpLanguageUrl(locale.appLocale);
        setIframeSrc(`${env.appUrl}/sparking-up-your-workshop${localeCode}/index.html`);
    }, [locale]);

    return (
        <MainLayout isHideSidebar={true}>
            {iframeSrc
                && <iframe
                    src={iframeSrc}
                    id='storyline'
                    title='e-learningframe'
                    className='pointer-events-auto w-screen absolute overflow-hidden'
                    allowFullScreen
                    style={{
                        height: '88%',
                    }}
                    ref={iframeRef}
                />
            }
        </MainLayout>
    );
};

export default SparkingUpYourWorkshop;